(function ($) {

    // ── Inline discount code form ──────────────────────────────────────────
    $(document)
        .off('click.coupon', '#checkout-coupon-apply')
        .on('click.coupon', '#checkout-coupon-apply', function () {
            var $btn    = $(this);
            var $wrap   = $btn.closest('.checkout-coupon-inline');
            var $msg    = $wrap.find('.checkout-coupon-inline__msg');
            var $input  = $wrap.find('.checkout-coupon-inline__input');
            var code    = $.trim($input.val());
            var nonce   = $wrap.data('nonce');

            if (!code) {
                $msg.html('<span class="checkout-coupon-inline__msg--error">Please enter a coupon code.</span>');
                return;
            }

            $btn.prop('disabled', true).addClass('checkout-coupon-inline__btn--loading');
            $msg.html('');

            // POST to WooCommerce's real apply_coupon endpoint, then refresh totals
            $.post(
                wc_checkout_params.ajax_url,
                {
                    action:      'woocommerce_apply_coupon',
                    security:    nonce,
                    coupon_code: code
                },
                function (response) {
                    if (response) {
                        // WC returns rendered notice HTML — show it briefly
                        $msg.html(response);
                    }
                    $btn.prop('disabled', false).removeClass('checkout-coupon-inline__btn--loading');
                    $input.val('');
                    // Refresh the order review totals
                    $('body').trigger('update_checkout');
                    // After WC rerenders the fragment, read the fresh nonce from the new DOM
                    $(document.body).one('updated_checkout', function () {
                        var $freshWrap = $('.checkout-coupon-inline');
                        if ($freshWrap.length) {
                            $wrap = $freshWrap;
                        }
                    });
                }
            );
        });

    $(document)
        .off('keydown.coupon', '#checkout-coupon-code')
        .on('keydown.coupon', '#checkout-coupon-code', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                $('#checkout-coupon-apply').trigger('click');
            }
        });

    // ── Checkout step navigation ───────────────────────────────────────────
    $('body').on('click', '.js-checkout-step', function (e){
        e.preventDefault();

        let that = $(this),
            href = that.attr('href'),
            step = that.parents('.checkout-steps__item'),
            step_index = step.index()  + 1;

        // Before advancing from step 1, validate required shipping fields
        if ( href === '#checkout-step-2' && !that.is('.js-checkout-step_current') ) {
            var invalid = false;

            // WooCommerce puts validate-required / validate-email on the .form-row wrapper,
            // not on the <input> itself — so we target the wrapper and check its field.
            $('#checkout-step-1').find('.form-row').each(function () {
                var $row    = $(this);
                var $field  = $row.find('input, select, textarea').first();
                var val     = $.trim( $field.val() );
                var isReq   = $row.hasClass('validate-required');
                var isEmail = $row.hasClass('validate-email');
                var label   = $.trim( $row.find('> label').clone().children().remove().end().text() );
                var rowInvalid = false;
                var errorMsg   = '';

                if ( isReq && val === '' ) {
                    $row.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                    errorMsg   = label ? label + ' is required.' : 'This field is required.';
                    rowInvalid = true;
                } else if ( isEmail && val !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) ) {
                    $row.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-email');
                    errorMsg   = 'Please enter a valid email address.';
                    rowInvalid = true;
                } else {
                    $row.removeClass('woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email').addClass('woocommerce-validated');
                }

                // Insert or remove the inline error message
                $row.find('.checkout-field-error').remove();
                if ( rowInvalid ) {
                    $row.append( '<span class="checkout-field-error" role="alert">' + errorMsg + '</span>' );
                    invalid = true;
                }
            });

            // Clear error messages when the user starts correcting a field
            $('#checkout-step-1').find('input, select, textarea').off('input.stepvalidate change.stepvalidate').on('input.stepvalidate change.stepvalidate', function () {
                var $row = $(this).closest('.form-row');
                $row.removeClass('woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email');
                $row.find('.checkout-field-error').remove();
            });

            if (invalid) {
                $('#checkout-step-1').find('.woocommerce-invalid').first().find('input, select, textarea').trigger('focus');
                return;
            }
        }

        // add class on step item
        $('.checkout-steps__item:lt(' + step_index + ')').addClass('checkout-steps__item_prev');
        $('.checkout-steps__item:gt(' + step_index + ')').removeClass('checkout-steps__item_prev');

        // check current expand trigger or not
        if(that.is('.js-checkout-step_current')){
            step.removeClass('checkout-steps__item_prev');
        }

        // collapse content
        $('.checkout-steps__item-content').removeClass('active');
        $(href).addClass('active');
    });
})(jQuery);